<template>
  <loading :active="this.allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <Dialog v-model:visible="showModal" class="lg:w-1/3 md:w-2/3 sm:w-2/3 d2-dialog-mobile-full bg-white shadow rounded-xl" :modal="true">
    <template #header>
      <div class="w-full text-center d2-dialog-header-title">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_title']}}</div>
    </template>
    <div class="align-middle inline-block min-w-full min-h-1/2 h-96 shadow overflow-auto bg-white shadow-dashboard d2-dialog-px pt-3 rounded-bl-lg rounded-br-lg">
      <div class="text-gray-500 text-sm px-2 d2-dialog-mb break-words">
        <a href="https://www.facebook.com/settings?tab=business_tools&ref=settings" target="_blank">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_to_fb_client']}}</a>
      </div>
      <table class="min-w-full">
        <thead>
          <tr>
            <th class="px-2 py-3 border-b border-gray-500 text-left text-sm text-gray-900">
              {{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_list_text']}}({{ list.length }})
              </th>
            <th class="px-2 py-3 border-b border-gray-500 text-right text-sm text-gray-900">
              <InputSwitch v-model="isSelect" @click="selectAll()" class="-my-1" />
              <span class="mx-1">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_all_check_button_text']}}</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-white record-table">
          <tr
            class="hover:bg-blue-200" v-for="(item, index) in list" :key="index"
            :class="{'bg-blue-200': (item.status == 1 && item.checked) || (item.status == 1 && isSelect)}"
            @click="item.checked =! item.checked"
          >
            <td
              class="whitespace-no-wrap border-b border-gray-200"
              :class="{'cursor-pointer' : item.status == 1}"
            >
              <div class="flex p-1">
                <div class="md:flex-shrink-0">
                  <img class="h-12 w-12 rounded-xl object-cover"
                    :src="item.imgSrc"
                  >
                </div>
                <div class="flex items-center justify-center mx-4">
                  <p class="text-gray-500">{{ item.name }}</p>
                </div>
              </div>
            </td>
            <td
              class="px-2 py-2 whitespace-no-wrap border-b border-gray-200 text-right text-gray-400 "
              :class="{'cursor-pointer' : item.status == 1}"
            >
              <span v-if="item.status == 0">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_check_status_linked_text']}}</span>
              <span
                class="text-blue-400 underline"
                v-if="(item.status == 1 && !item.checked) && (item.status == 1 && !isSelect)"
              >{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_check_status_linkable_text']}}</span>
              <span
                class="text-blue-800"
                v-if="(item.status == 1 && item.checked) || (item.status == 1 && isSelect)"
              >
                <i class="pi pi-check mr-2"></i>
                {{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_check_status_selected_text']}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <template #footer>
      <div class="d2-btn-row" style="justify-content: flex-end;">
        <button
          class="d2-btn-ghost"
          @click="showModal=false">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_check_cancel_button_text']}}</button>
        <button
          class="d2-btn d2-btn-yellow"
          @click="updateFanAdaccount()">{{lang['components']['Dialog']['ConnectFanPageDialog']['connect_fan_page_check_update_button_text']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import InputSwitch from 'primevue/inputswitch';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'ConnectFanPageDialog',
    components: {
      Dialog,
      InputSwitch,
      Swal,
      Loading
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      connectId: {
        type: String,
        default: 'test'
      },
      lang: {
        type: Object
      },
    },
    data() {
      return {
        allPageLoading: false,
        showDetail: false,
        isSelect: false,
        list: null
        // list: [{
        //     name: 'Future Lab1',
        //     imgSrc: 'http://placehold.it/100x100',
        //     status: 0
        //   },
        //   {
        //     name: 'Future Lab2',
        //     imgSrc: 'http://placehold.it/100x100',
        //     status: 1
        //   },
        //   {
        //     name: 'Future Lab3',
        //     imgSrc: 'http://placehold.it/100x100',
        //     status: 2
        //   }
        // ]
      }
    },
    mounted() {
      axios
        .post('https://www.autoturn.net/api/adaccount.php', Qs.stringify({
          s_code: this.$route.params.id,
          id: this.connectId
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('response:'+response.data);
            // self.first_name = response.data.firstName;
            // this.first_name = response.data.firstName
            this.list = response.data.return_data;
          }
        });
    },
    methods: {
      selectAll (event) {
        // console.log(this.isSelect);
        if (!this.isSelect) {
          // console.log('is checked');
          this.list.map(function(value, key) {
            // console.log('value:'+value.name)
            if(value.status == 1){
              value.checked = true;
            }
          });
        } else {
          // console.log('un checked');
          this.list.map(function(value, key) {
            // console.log('value:'+value.name)
            if(value.status == 1){
              value.checked = false;
            }
          });
        }
      },
      updateFanAdaccount(){
        // console.log('connectId');
        // console.log(this.connectId);
        // console.log('list');
        // console.log(this.list);

        let adaccountId = this.connectId
        let list = this.list
        let member_hash = this.$route.params.id
        let type = this.$route.params.type

        axios
          .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: type,
            active: 'member',
          }))
          .then((caResponse) => {

            if(caResponse.data.status == 'error'){
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/"+type+"/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "hhttps://private.autoturn.net/"+type+"/"+member_hash;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   // Swal.fire('Saved!', '', 'success')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // } else if (result.isDenied) {
                  //   // Swal.fire('Changes are not saved', '', 'info')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }

                  // if (result.dismiss === Swal.DismissReason.timer) {
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }
                })
              } else {
                Swal.fire(
                          this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning'){
              Swal.fire({
                icon: 'warning',
                title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .post('https://www.autoturn.net/api/data/fan_adaccount_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      adaccount_id: adaccountId,
                      form_data: list
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      // if(response.data.status == 'success'){
                        // this.$swal(response.data.info);
                        // this.showModal = false;
                      if(response.data.status == 'login'){
                        Swal.fire({
                          icon: 'error',
                          title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['confirm_button']
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            // this.allPageLoading = true
                            window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                          }
                        })
                      } else {
                        Swal.fire({
                          icon: response.data.status,
                          title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['warning']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.showModal = false;
                            this.allPageLoading = true;
                            window.location.reload();
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.showModal = false;
                            this.allPageLoading = true;
                            window.location.reload();
                          }
                        })
                      }
                      // }
                    });
                }
              });
            }

            if(caResponse.data.status == 'success'){
              axios
                .post('https://www.autoturn.net/api/data/fan_adaccount_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: adaccountId,
                  form_data: list
                }))
                .then((response) => {
                  // console.log(response.data);
                  // if(response.data.status == 'success'){
                    // this.$swal(response.data.info);
                    // this.showModal = false;
                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['success']['swal_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['success']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                      }
                    })
                  } else {
                    Swal.fire({
                      icon: response.data.status,
                      title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['success']['swal_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['success']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.showModal = false;
                        this.allPageLoading = true;
                        window.location.reload();
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.showModal = false;
                        this.allPageLoading = true;
                        window.location.reload();
                      }
                    })
                  }
                  // }
                });
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['login']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['Dialog']['ConnectFanPageDialog']['updateFanAdaccount']['axios']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+member_hash+"?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+member_hash+"?o=1";
                }
              })
            }
          });
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      connectIdData: {
        get: function () {
          return this.connectId
        },
        set: function (value) {
          this.$emit('update:connectIdData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scope>
  .record-table {
    button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }
</style>